import { maxBy } from 'es-toolkit';

import { AnalysisHistoryRecord } from '@paragon/contract-library';
import { sortBy } from '@paragon/utilities';

export function getMostRecentAnalysis(history: readonly AnalysisHistoryRecord[]): AnalysisHistoryRecord | undefined {
  return maxBy(history, (analysisHistoryRecord) => Date.parse(analysisHistoryRecord.timestamp));
}

export function sortAnalysisHistoryDescending(
  history: readonly AnalysisHistoryRecord[],
): readonly AnalysisHistoryRecord[] {
  return sortBy(history, (analysisHistoryRecord) => Date.parse(analysisHistoryRecord.timestamp), 'desc');
}
